export default "__VITE_PUBLIC_ASSET__18780b5a__"